import { render, staticRenderFns } from "./FaceRecognition.vue?vue&type=template&id=31818a70&scoped=true&"
import script from "./FaceRecognition.vue?vue&type=script&lang=js&"
export * from "./FaceRecognition.vue?vue&type=script&lang=js&"
import style0 from "./FaceRecognition.vue?vue&type=style&index=0&id=31818a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31818a70",
  null
  
)

export default component.exports